import { dxtToLocalServerTime } from "@dexteel/mesf-core";

import { CallSplit, Comment } from "@mui/icons-material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import { useState } from "react";
import { MenuOptionType } from "@/controls/contextMenu/models/MenuOptionType";
import { DelayByShift } from "../models/DelayByShift";

type Props = {
  setSelectedId: (id: number | null) => void;
  setShowModal: (
    show: "new" | "edit" | "delete" | "justify" | "split" | "",
  ) => void;
};

export const useDelaysOptionFunctions = ({
  setSelectedId,
  setShowModal,
}: Props) => {
  const [messageDeleteModal, setMessageDeleteModal] = useState("");

  // Create
  const createData = () => {
    setShowModal("new");
  };

  // Edit
  const editData = (data: DelayByShift) => {
    setSelectedId(data.DelayId);
    if (data.IsManual) {
      setShowModal("edit");
    }
  };

  // Justify
  const justifyData = (data: DelayByShift) => {
    setSelectedId(data.DelayId);
    setShowModal("justify");
  };

  // Split
  const splitData = (data: DelayByShift) => {
    setSelectedId(data.DelayId);
    setShowModal("split");
  };

  // Delete
  const deleteData = (data: DelayByShift) => {
    setSelectedId(data.DelayId);
    const dateOpen = dxtToLocalServerTime(data.Start, "HH:mm:ss");
    setMessageDeleteModal(
      `The delay at ${dateOpen} will be deleted. Do you want to continue?`,
    );
    setShowModal("delete");
  };

  // Get Menu options
  const getMenuOptions = (data: DelayByShift) => {
    let options: MenuOptionType[] = [];

    if (data) {
      options = options.concat([
        {
          name: "Justify Delay",
          key: "justify_delay",
          onClick: () => justifyData(data),
          icon: <Comment />,
        },
        {
          name: "Edit Delay",
          key: "edit_delay",
          onClick: () => editData(data),
          icon: <Edit />,
          disabled: !data.IsManual,
        },
        {
          name: "Delete Delay",
          key: "delete_delay",
          onClick: () => deleteData(data),
          icon: <DeleteIcon />,
          disabled: !data.IsManual,
        },
        {
          name: "Split Delay",
          key: "split_delay",
          onClick: () => splitData(data),
          icon: <CallSplit />,
        },
      ]);
    }
    options.push({
      name: "New Delay",
      key: "create_new_delay",
      onClick: () => createData(),
      icon: <PlaylistAddIcon />,
    });

    return options;
  };

  return {
    createData,
    editData,
    deleteData,
    justifyData,
    getMenuOptions,
    messageDeleteModal,
    setMessageDeleteModal,
  };
};
